import { Alert, Snackbar } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { noticeQuery } from '../../../core/mapV2/queries';
import { noticeSet } from '../../../core/mapV2/state';
import { useAppDispatch, useAppSelector } from '../../../types';

const AUTO_HIDE_MS = 4000;

// Confirmation after a referential edit: "Référentiel mis à jour : catégorie sur 3 tronçons".
export const EditNotice: FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const notice = useAppSelector(noticeQuery);

    return (
        <Snackbar
            open={notice !== null}
            autoHideDuration={AUTO_HIDE_MS}
            onClose={() => dispatch(noticeSet(null))}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert severity="success" variant="filled" onClose={() => dispatch(noticeSet(null))}>
                {notice
                    ? t('mapV2.edit.done', {
                          field: t(`mapV2.sheet.${notice.field}`).toLowerCase(),
                          count: notice.count,
                      })
                    : ''}
            </Alert>
        </Snackbar>
    );
};
